
import { useAuth, PermissionPayload } from "../../modules/auth";
import CrudArtEngenheiroTransportador from "../../components/transportador/art/CrudArtEngenheiroTransportador.vue";
import {
  useDashboardService,
  DashboarPayload
} from "../../modules/business/cliente/dashboardBusiness";
import { defineComponent, reactive, onMounted } from "vue";
import { useToast } from "../../modules/message";
import { PaginationResult, defaultResults } from "../../pagination";

interface DashboardState {
  entity: DashboarPayload | null;
  page: number;
  responseConsulta: boolean;
  responseCadastro: boolean;
  saldoAntiCaptcha: string | null;
  saldoHcaptcha: string | null;
  results: PaginationResult<DashboarPayload>;
}

export default defineComponent({
  components: {
    CrudArtEngenheiroTransportador
  },
  setup() {
    const state = reactive<DashboardState>({
      entity: null,
      page: 0,
      responseConsulta: false,
      responseCadastro: false,
      saldoAntiCaptcha: null,
      saldoHcaptcha: null,
      results: defaultResults()
    });

    const dashboardService = useDashboardService();

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const executeBuscaSaldoAntiCaptcha = async () => {
      try {
        await dashboardService.getSaldoAntiCaptcha();
        const saldoResponse = dashboardService.data.value;
        const saldo = saldoResponse.balance;
        state.saldoAntiCaptcha = saldo;
        return saldo;
      } catch (error) {
        useToast().error("Falha ao buscar saldo AntiCaptcha");
        return null;
      }
    };

    const executeBuscaSaldoHcaptcha = async () => {
      try {
        await dashboardService.getSaldoHcaptcha();
        const saldoResponse = dashboardService.data.value;
        const saldo = saldoResponse.saldo;
        state.saldoHcaptcha = saldo;
        return saldo;
      } catch (error) {
        useToast().error("Falha ao buscar saldo Hcaptcha");
        return null;
      }
    };

    const executeBuscaStatusConsulta = async () => {
      await dashboardService.isRoboConsultaHabilitado();
      const consultaResponse = dashboardService.data.value;
      state.responseConsulta = consultaResponse;
      return consultaResponse;
    };

    const executeBuscaStatusCadastro = async () => {
      await dashboardService.isRoboCadastroHabilitado();
      const cadastroResponse = dashboardService.data.value;
      state.responseCadastro = cadastroResponse;
      return cadastroResponse;
    };

    const executeDesligarRoboConsulta = async () => {
      try {
        await useDashboardService().desligarRoboConsulta();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboConsulta = async () => {
      try {
        await useDashboardService().ligarRoboConsulta();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusConsulta();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeDesligarRoboCadastro = async () => {
      try {
        await useDashboardService().desligarRoboCadastro();
        useToast().success("Robos desligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao desligar os Robos");
      }
    };

    const executeLigarRoboCadastro = async () => {
      try {
        await useDashboardService().ligarRoboCadastro();
        useToast().success("Robos ligados com sucesso");
        executeBuscaStatusCadastro();
      } catch {
        useToast().error("Falha ao ligar os Robos");
      }
    };

    const executeSearchFilaRobo = () => {
      const { data, getDadosFilaRobo } = useDashboardService();
      return getDadosFilaRobo(state.page).then(() => {
        if (data.value && data.value.content) {
          const resultTratado: DashboarPayload[] = data.value.content.map(
            (item: DashboarPayload, index: number) => {
              item.groupIndex = index;
              return item;
            }
          );
          data.value.content = resultTratado;
          state.results = data.value;
        } else {
          state.results = defaultResults();
        }
      });
    };

    const getFila = (e?: DashboarPayload) => {
      return useDashboardService().getFila(e);
    };

    const getSigla = (e?: DashboarPayload) => {
      return useDashboardService().getSigla(e);
    };

    const getStatusRobo = (e?: DashboarPayload) => {
      return useDashboardService().getStatusRobo(e);
    };

    const getQuantidade = (e?: DashboarPayload) => {
      return useDashboardService().getQuantidade(e);
    };

    onMounted(() => {
      executeBuscaStatusCadastro();
      executeBuscaStatusConsulta();
      executeSearchFilaRobo();
      executeBuscaSaldoAntiCaptcha();
      executeBuscaSaldoHcaptcha();
    });

    return {
      state,
      amIAllowed,
      executeBuscaStatusCadastro,
      executeBuscaStatusConsulta,
      executeDesligarRoboConsulta,
      executeLigarRoboConsulta,
      executeDesligarRoboCadastro,
      executeLigarRoboCadastro,
      executeBuscaSaldoHcaptcha,
      executeBuscaSaldoAntiCaptcha,
      executeSearchFilaRobo,
      getFila,
      getSigla,
      getStatusRobo,
      getQuantidade
    };
  }
});
